import { FileTypeName } from 'api/types/entity';
import { date, mixed, number, object, string } from 'libs/form';

export const localFileScheme = object({
  id: string(),
  name: string().required(),
  size: number().required(),
  createdAt: date().required(),
  type: mixed<FileTypeName>().oneOf(Object.values(FileTypeName)),
});
